import React from "react";
//import axios from 'axios';
import './Wallet.css';
import Breadcrumb from '../Components/Breadcrumb';
//import AuthService from '../Services/auth.service';
//import CartService from '../Services/cart.service';
//import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
//import Makepayment from '../Pop-up/Makepayment';
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
class Wallet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : '[]',
            modal: false,
            amount:'',
            payButton:'Next',
            walletLoader:''
    
    
        }
      
    }
    /*async componentDidMount(){
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
           //alert(USR_TOKEN)
            const user = await AuthService.getCurrentUser();
            this.setState({profile:user})
    axios.get(process.env.REACT_APP_API_URL + 'api/method/prettypets.api.wallet_balance',{
        headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
    })
    .then(response=>{
        this.setState({menu:response.data['message']})
        console.log(response.data['message'])
    })
    }
    else{
    alert("Not Logged in")
    }
    const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.body.appendChild(script);
    }*/
    /*async openRazor(e){
        if(this.state.amount > 0){
            e.preventDefault();   
            const user =  AuthService.getCurrentUser();

            await CartService.addMoney(this.state.amount)
            .then(res=>{  
                  
      
                 // this.setState({ orderDetails:res});
                 
                  var options = {
                    "key": 'rzp_test_v6nWNOJTSKQ7nu',
                    "name": "",
                    "description": "",
                    'order_id':"",
                    "handler": function(response) {
                        console.log(response);
                        //var values ={
                          //  razorpay_signature : response.razorpay_signature,
                          //  razorpay_order_id : response.razorpay_order_id,
                          //  transactionid : response.razorpay_payment_id                }
                        
                    },
                    "prefill":{
                        "name":user.full_name,
                        "email":user.email,
                        "contact":user.mobile_no,
                    },
                    "notes": {
                      "address": ''
                    },
                    "theme": {
                      "color": "#528ff0"
                    }
                  };
      
                  
                  console.log("res.data.id")
                  console.log(res.data.message.id)
                  if(res.data.message.id){
                      this.setState({ walletLoader:'Wallet Updated.'});
                      options.order_id = res.data.message.id;
                      options.amount = this.state.cartTotal*100;
                    
                      localStorage.setItem("orderID", res.data.message.id);
                     // window.location.href = "/payment.html"
                      var rzp1 = new window.Razorpay(options);
                      rzp1.open();
                      this.setState({ checkoutLoader:'Processing Payment...'});
      
                  }
                  
      
            })

        }
        
    }*/
   

    /*onAmountChange(e){
         const { value} = e.target;
         if(value > 0){
            this.setState({ amount: value });
         }
         
   
    }
    async addAmuont (e, amount){
        e.preventDefault();
        if(amount > 0){
            this.setState({ amount: amount });
        }
            
    }*/
      
  render() {
    return <div>
        <div className="container mt-4 pt-4">
        <Breadcrumb head="My Wallet"/>
            <div className="row">
                <div className="col-md-4">
                    <h2>Wallet</h2>
                </div>
                <div className=" col-md-5 ">
                        <p className="manage">You can manage and set your profile information here</p>
                        
                        <div className="wallet-balance"> 
                                <span className="price">Current Wallet Balance<p>₹&nbsp;&nbsp;{this.state.menu}</p></span>
                        </div>
                        <h3>Add Money to Wallet</h3>
                        <div className="row-form">
                        <input className="form-controls" id="amountInput" type="text" onChange={this.onAmountChange} defaultValue={this.state.amount} placeholder="Enter Amount" />
                        </div>  
                        <div className="tag_bottom">
                            <button type="button" className=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn"  onClick={(e) => { this.addAmuont(e, '100');}}><u>₹&nbsp;&nbsp;&nbsp;100</u></button>
                            <button type="button" className=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn" onClick={(e) => { this.addAmuont(e, '500');}}><u>₹&nbsp;&nbsp;&nbsp;500</u></button>
                            <button type="button" className=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn" onClick={(e) => { this.addAmuont(e, '1000');}}><u>₹&nbsp;&nbsp;&nbsp;1000</u></button>
                        </div>
                        <a href="/#"><button type="button" className=" add-to-cart2 btnn mt-31" onClick={e => this.openRazor(e)}>{this.state.payButton}</button></a>
                               {/*    <Modal
                                        size="lg"
                                        isOpen={this.state.modal}
                                     toggle={this.handleClose}
                                        show={this.state.modal}
                                         onHide={this.state.setPop}
                                    >
                            
                            <ModalHeader toggle={() => this.setState({ modal: false })}>
                            </ModalHeader>
                            <ModalBody>
                                  <Makepayment />

                            </ModalBody>
                          
                            </Modal> */} 
                        <br/>
                        <br/>
                        <br/>
                        <h3> Wallet Options</h3>
                        
                        <p className="green-link my-link mb-5"><a href="/wallet-transfer">Show All Transaction History {/*<ArrowForwardIcon/>*/}</a></p>
                    
                </div>
                <div className=" col-md-3 "> 
                </div>
                </div>
    </div>
</div>
    }
}
export default Wallet;